export default {
  namespaced: true,
  external_token: {
    title: "token externo | tokens externos",
    description: "descripción",
    token: "token",
  },
};
